import './styles.scss'
import UnbeatableSection from '../../Components/UnbeatableSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

const ContactUs = () => {
  return (
    <div className="contact-us">
      <div className="contact-us__top">
        <h1>Contact Us</h1>
      </div>

      <div className="contact-us__content">
        <section className="contact-us__content__details">
          <div className="contact-us__content__details__content">
            <p>
              Nexus Cargo is available early and after hours to meet your
              messenger and courier delivery needs. Call us anytime for a free
              quote and join the ranks of satisfied customers.
            </p>

            <div className="contact-item">
              <div className="contact-item__icon-wrap">
                <FontAwesomeIcon className="icon" icon={solid('phone')} />
              </div>
              <div className="contact-item__text">
                <span className="label">Phone</span>
                <span className="value"> </span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item__icon-wrap">
                <FontAwesomeIcon className="icon" icon={solid('map')} />
              </div>
              <div className="contact-item__text">
                <span className="label">Address</span>
                <span className="value">Global Facility Office</span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item__icon-wrap">
                <FontAwesomeIcon className="icon" icon={solid('envelope-open')} />
              </div>
              <div className="contact-item__text">
                <span className="label">Email</span>
                <span className="value">contact@nexuscargo.us</span>
              </div>
            </div>
          </div>

          <div className="contact-us__content__details__cta">
            <h3>We're here for you.</h3>
            <p>
              Based in the US and delivering everywhere. Whether it's a single
              package or a full freight operation — reach out and we'll get back
              to you fast.
            </p>
            <div className="hours">
              <span>Operating Hours</span>
              <strong>Mon – Fri: 8:00 AM – 8:00 PM</strong>
              <strong>Sat – Sun: 9:00 AM – 5:00 PM</strong>
            </div>
          </div>
        </section>

        <UnbeatableSection />
      </div>
    </div>
  )
}

export default ContactUs
